import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <p>PrivacyPolicy</p>
    </div>
  );
};

export default PrivacyPolicy;
